// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"474":"4d1632e1","974":"9ac4f33d"}[chunkId] + ".chunk.js";
};